import { useContext } from "react";

import SurveyCapturedSummaryShell from "../survey-shape/SurveyCapturedSummaryShell";
import { SurveyContext } from "../survey-shape/SurveyContext";
import {
  formatSubcategoryLabel,
  formatProductWeight,
  formatElectronics,
  formatMaterialsList,
  formatPackaging,
  formatRoute
} from "../product-bom-fields/formatProductBomEntries";

const buildEntries = (values) => [
  {
    fieldId: "productWeight",
    label: "Product weight",
    required: true,
    value: formatProductWeight(values?.productWeight)
  },
  {
    fieldId: "subcategory",
    label: "Category",
    required: true,
    value: formatSubcategoryLabel(values?.category, values?.subcategory)
  },
  {
    fieldId: "components",
    label: "Components",
    required: true,
    value: formatMaterialsList(values?.components)
  },
  {
    fieldId: "electronics",
    label: "Electronics",
    value: formatElectronics(values?.electronics)
  },
  {
    fieldId: "packaging",
    label: "Packaging",
    required: true,
    value: formatPackaging(values?.packaging, values?.packagingWeight)
  },
  {
    fieldId: "route",
    label: "Shipping route",
    required: true,
    value: formatRoute(values?.route)
  }
];

const BomSurveyCapturedSummary = ({
  isMobileDrawer = false,
  onCloseMobile
}) => {
  const context = useContext(SurveyContext);
  const entries = buildEntries(context?.currentBomValues || {});
  return (
    <SurveyCapturedSummaryShell
      title="BOM so far"
      subtitle="Collapse Scout to edit any field directly."
      entries={entries}
      isMobileDrawer={isMobileDrawer}
      onCloseMobile={onCloseMobile}
    />
  );
};

export default BomSurveyCapturedSummary;
